import React from 'react'

import {
    GroupCoverage,
    IndividualCoverage,
    GroupStdCoverage,
} from '../../../variables/InitialValues'

import RenderFieldArray from 'components/RenderFieldArray/RenderFieldArray'
import { useFormikContext } from 'formik'

import FormNavigationButtons from './FormNavigationButtons'
import IpsaSelectField from './Form/IpsaSelectField'
import { IpsaMoneyField, IpsaPercentField, IpsaNumberField } from './Form/IpsaFormattedFields'
import styled from 'styled-components'

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-content: center;
    flex-wrap: wrap;
    padding: 10px 0;
`

const InputContainer = styled.div`
    display: flex;
    align-items: center;
`

const GroupStdCoverageForm = ({ index }) => {
    return (
        <div className="col-section col-no-margin">
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaPercentField
                    name={`coverage.groupStdCoverages.${index}.percentCovered`}
                    type="text"
                    label="Percent Covered"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.groupStdCoverages.${index}.weeklyMaximum`}
                    type="text"
                    label="Weekly Maximum / Cap"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['0', '7', '14', '30']}
                    name={`coverage.groupStdCoverages.${index}.waitingPeriod`}
                    label="Waiting Period (Days)"
                    placeholder="Select Waiting/Elimination Period"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={[13, 17, 26, 52]}
                    name={`coverage.groupStdCoverages.${index}.benefitPeriod`}
                    label="Benefit Period (Weeks)"
                    placeholder="Select Benefit Period"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['Yes', 'No']}
                    name={`coverage.groupStdCoverages.${index}.includeBonus`}
                    label="Include Bonus / Commission/ K1?"
                    placeholder="Select Include Bonus/Commission/K1?"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.groupStdCoverages.${index}.annualPremium`}
                    type="text"
                    label="Annual Premium"
                    informationText="If the Group STD is employer paid and the premiums are not shared by the employee, enter $0.  However, if the employee pays all or part of the cost, enter in the annualized premium amount."
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['Yes', 'No']}
                    name={`coverage.groupStdCoverages.${index}.taxableBenefits`}
                    label="Taxable Benefits?"
                    placeholder="Select are Benefits Taxable?"
                    informationText="Most employer provided STD plan premiums are paid for by the employer, so the benefits would be taxable.  However, in certain circumstances, if the employee pays all or part the premiums the benefits may be all or partially non-taxable."
                />
            </InputContainer>
        </div>
    )
}

const GroupCoverageForm = ({ index }) => {
    return (
        <div className="col-section col-no-margin">
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaPercentField
                    name={`coverage.groupCoverages.${index}.percentCovered`}
                    type="text"
                    label="Percent Covered"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.groupCoverages.${index}.monthlyMaximum`}
                    type="text"
                    label="Monthly Maximum / Cap"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['0', '30', '60', '90', '120', '180', '365']}
                    name={`coverage.groupCoverages.${index}.waitingPeriod`}
                    label="Waiting Period"
                    placeholder="Select Waiting/Elimination Period"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={[1, 2, 5, 10, 65, 67, 70]}
                    name={`coverage.groupCoverages.${index}.benefitPeriod`}
                    label="Benefit Period"
                    placeholder="Select Benefit Period"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['Yes', 'No']}
                    name={`coverage.groupCoverages.${index}.includeBonus`}
                    label="Include Bonus / Commission/ K1?"
                    placeholder="Select Include Bonus/Commission/K1?"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.groupCoverages.${index}.annualPremium`}
                    type="text"
                    label="Annual Premium"
                    informationText="If the Group LTD is employer paid and the premiums are not shared by the employee, enter $0.  However, if the employee pays all or part of the cost, enter in the annualized premium amount."
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['Yes', 'No']}
                    name={`coverage.groupCoverages.${index}.taxableBenefits`}
                    label="Taxable Benefits?"
                    placeholder="Select are Benefits Taxable?"
                    informationText="Most employer provided LTD plan premiums are paid for by the employer, so the benefits would be taxable.  However, in certain circumstances, if the employee pays all or part the premiums the benefits may be all or partially non-taxable."
                />
            </InputContainer>
        </div>
    )
}

const IndividualCoverageForm = ({ index, value }) => {
    return (
        <div className="col-section col-no-margin">
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.individualCoverages.${index}.benefitAmount`}
                    type="text"
                    label="Benefit Amount (Monthly)"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.individualCoverages.${index}.monthlyMaximum`}
                    type="text"
                    label="Monthly Maximum / Cap"
                    informationText="This is the maximum monthly benefit the carrier can go up to."
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={[0, 30, 60, 90, 120, 180, 365]}
                    name={`coverage.individualCoverages.${index}.waitingPeriod`}
                    label="Waiting Period"
                    placeholder="Select Waiting/Elimination Period"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={[1, 2, 5, 10, 65, 67, 70]}
                    name={`coverage.individualCoverages.${index}.benefitPeriod`}
                    label="Benefit Period"
                    placeholder="Select Benefit Period"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['0%', '1%', '2%', '3%', '4%', '5%', '6%']}
                    name={`coverage.individualCoverages.${index}.cola`}
                    label="COLA %"
                    placeholder="Select COLA %"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['0%', '1%', '2%', '3%', '4%', '5%', '6%']}
                    name={`coverage.individualCoverages.${index}.futureIncrease`}
                    label="Annual Benefit Increase"
                    placeholder="Select Annual Benefit Increase %"
                    informationText="Each carrier has their own version of this provision.  This feature helps the benefit keep pace with inflation and increasing income while the client is working and not on claim"
                />
            </InputContainer>

            {value && value.futureIncrease && value.futureIncrease !== '0%' && (
                <InputContainer className="col-xs-12 col-md-3">
                    <IpsaNumberField
                        name={`coverage.individualCoverages.${index}.futureIncreaseMaxAge`}
                        type="text"
                        label="Max Age for Annual Benefit Increase"
                        informationText="Each carrier will have a maximum age the benefit will increase to.  Some carriers state it in years (typically 5 or 6 years from policy issue date) or until a maximum age, which is typically age 55"
                    />
                </InputContainer>
            )}
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaMoneyField
                    name={`coverage.individualCoverages.${index}.annualPremium`}
                    type="text"
                    label="Annual Premium"
                />
            </InputContainer>
            <InputContainer className="col-xs-12 col-md-3">
                <IpsaSelectField
                    values={['Yes', 'No']}
                    name={`coverage.individualCoverages.${index}.taxableBenefits`}
                    label="Taxable Benefit"
                    placeholder="Select are Benefits Taxable?"
                />
            </InputContainer>
        </div>
    )
}

const CurrentCoverageStep = ({ clientId, onSave }) => {
    const { values } = useFormikContext()
    const {
        coverage: { groupCoverages, groupStdCoverages, individualCoverages },
    } = values

    return (
        <>
            <div id="new-client-1" className="new-client-form animated-form">
                <HeaderContainer>
                    <h2>Current Group STD Coverage</h2>

                    <RenderFieldArray
                        field="coverage.groupStdCoverages"
                        values={groupStdCoverages}
                        newItem={GroupStdCoverage}
                        allowZero
                    >
                        <GroupStdCoverageForm />
                    </RenderFieldArray>
                </HeaderContainer>
                <HeaderContainer>
                    <h2>Current Group LTD Coverage</h2>

                    <RenderFieldArray
                        field="coverage.groupCoverages"
                        values={groupCoverages}
                        newItem={GroupCoverage}
                        allowZero
                    >
                        <GroupCoverageForm />
                    </RenderFieldArray>
                </HeaderContainer>

                <HeaderContainer>
                    <h2>Current Individual DI Coverage</h2>
                    <RenderFieldArray
                        allowZero
                        field="coverage.individualCoverages"
                        values={individualCoverages}
                        newItem={IndividualCoverage}
                    >
                        <IndividualCoverageForm />
                    </RenderFieldArray>
                </HeaderContainer>
            </div>
            <FormNavigationButtons
                section="coverage"
                previous="client"
                next="assets"
                onSave={onSave}
                clientId={clientId}
            />
        </>
    )
}

export default CurrentCoverageStep
